import { AddToCalendarButton } from "add-to-calendar-button-react";
import { DateTime } from "luxon";
import { Alert, Stack, Text, Button, Group } from "@mantine/core";
import { useContext } from "react";
import { CompanyContext } from "../pre_app/CompanyGateway";
import { LocationContext } from "../pre_app/LocationGateway";

export default function ConfirmedReservation({time, duration, bayName, close}: {time: DateTime, duration: number, bayName: string, close: ()=>void}) {
    const company = useContext(CompanyContext);
    const location = useContext(LocationContext);
    
    return <Stack>
      <Alert>
        <Text>{time.toFormat("LLL dd @ HH:mm")} for {duration} minutes is booked!</Text>
        This reservation will be at <Text fw={700} span>{bayName}</Text>
      </Alert>
      <Group justify="space-between">
        <AddToCalendarButton
          name={`${company.name} - ${bayName}`}
          description={`${duration} minute reservation at ${company.name} - ${bayName}.`}
          startDate={time.toFormat("yyyy-LL-dd")}
          startTime={time.toFormat("HH:mm")}
          endTime={time.plus({minutes: duration}).toFormat("HH:mm")}
          options={['Apple', 'Google', 'Yahoo', 'iCal']}
          timeZone={location.tz}
          forceOverlay={true}
          location={location.address}
        />
        <Button onClick={close}>Done</Button>
      </Group>
      
    </Stack>
}